import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import Icon from '@components/icon/icon.component'

import useStyles from './button.style'

import { BLUE } from '@omnilert/components'

const Button = forwardRef((props, ref) => {
  const {
    children,
    className,
    disabled,
    icon,
    isLoading,
    onClick,
    iconStyle,
    type,
    backgroundColor,
    style
  } = props

  const loading = isLoading ? 'is-loading' : ''

  const classes = useStyles(props)

  return (
    <button
      ref={ref}
      className={`${classes.button} ${className} ${loading}`}
      disabled={disabled}
      onClick={onClick}
      style={{ backgroundColor: backgroundColor, ...style }}
      type={type}
    >
      {children}
      {icon && !isLoading && <Icon
        style={iconStyle}
        type={icon}
      />}
    </button>
  )
})

Button.defaultProps = {
  backgroundColor: BLUE,
  children: null,
  className: '',
  icon: '',
  isLoading: false,
  onClick: () => {},
  style: {},
  type: ''
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  className: PropTypes.string,
  icon: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  type: PropTypes.string
}

export default Button
